export const SMALL_SCREEN_WIDTH = 576;
export const MEDIUM_SCREEN_WIDTH = 768;
export const MEDIUM_SCREEN_MAX_WIDTH = 991;
export const IFRAME_MAX_HEIGHT = 700;
export const IFRAME_MAX_FOOTER_HEIGHT = 100;
export const DASHBOARD_TWO_COLUMN_LAYOUT_MIN_WIDTH = 1300; // the value of window.width when our dashboard goes from 1 column of stacked widgets to 2 columns
